import * as React from 'react';
import QRCode from 'react-qr-code';

interface IQrCodeProps {
  value: string;
  size?: number;
  className?: string;
}

export const QrCodeComponent: React.FC<IQrCodeProps> = ({ value, size = 75, className }) => {
  return <QRCode value={value} size={size} className={className} />;
};
